export const allSchoolClasses = [
    {id: 1, name: "1 класс", ageText: "6-7"},
    {id: 2, name: "2 класс", ageText: "8"},
    {id: 3, name: "3 класс", ageText: "9"},
    {id: 4, name: "4 класс", ageText: "10"},
    {id: 5, name: "5 класс", ageText: "11"},
    {id: 6, name: "6 класс", ageText: "12"},
    {id: 7, name: "7 класс", ageText: "13"},
    {id: 8, name: "8 класс", ageText: "14"},
    {id: 9, name: "9 класс", ageText: "15"},
    {id: 10, name: "10 класс", ageText: "16"},
    {id: 11, name: "11 класс", ageText: "17"},
];

export const allRewardKinds = [
    {id: "award", name: "награда", pluralTitle: "награды"},
    {id: "olympiad", name: "олимпиада", pluralTitle: "олимпиады"},
    {id: "festival", name: "фестиваль", pluralTitle: "фестивали"},
];

export const allArtistRoles = [
    {id: "writer", name: "писатель", isAuthor: true},
    {id: "composer", name: "композитор", isAuthor: true},
    {id: "painter", name: "художник", isAuthor: true},
    {id: "architect", name: "архитектор", isAuthor: true},
    {id: "scientist", name: "учёный", isAuthor: true},
    {id: "photographer", name: "фотограф", isAuthor: true},
    {id: "director", name: "режиссёр", isAuthor: false},
    {id: "choreographer", name: "хореограф", isAuthor: false},
    {id: "actor", name: "актёр/актриса", isAuthor: false},
    {id: "historical_figure", name: "ист. личность", isAuthor: false},
];

export const allSuggestArtistRoles = [
    allArtistRoles.find(x => x.id === "writer"),
    allArtistRoles.find(x => x.id === "composer"),
    allArtistRoles.find(x => x.id === "painter"),
];

export const allAges = [
    {id: 0, name: "0+"},
    {id: 1, name: "1+"},
    {id: 2, name: "2+"},
    {id: 3, name: "3+"},
    {id: 4, name: "4+"},
    {id: 5, name: "5+"},
    {id: 6, name: "6+"},
    {id: 7, name: "7+"},
    {id: 8, name: "8+"},
    {id: 9, name: "9+"},
    {id: 10, name: "10+"},
    {id: 11, name: "11+"},
    {id: 12, name: "12+"},
    {id: 13, name: "13+"},
    {id: 14, name: "14+"},
    {id: 15, name: "15+"},
    {id: 16, name: "16+"},
    {id: 17, name: "17+"},
    {id: 18, name: "18+"},
];

export const allDayOfWeeks = [
    {id: 1, name: "Пн"},
    {id: 2, name: "Вт"},
    {id: 3, name: "Ср"},
    {id: 4, name: "Чт"},
    {id: 5, name: "Пт"},
    {id: 6, name: "Сб"},
    {id: 7, name: "Вс"},
];

export const allAuthorTagKinds = [
    {id: "occupation", name: "род деятельности"},
    {id: "art_genre", name: "жанр искусствоведения"},
    {id: "movement", name: "направление / стиль"},
    {id: "association", name: "творческие объединения"},
    {id: "other", name: "другие"},
];